import React, { FunctionComponent } from 'react'
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ReferenceArea,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'

import { FinancingScenario } from '../BuybackFormFinancingTable/BuybackFormFinancingTable'

interface BuybackFormFinancingChartProps {
  calculations: {
    scenarios: FinancingScenario[]
    loanAmount: number
    rentDurationMonths: number
    saleDurationMonths: number
  }
}

const formatCurrency = (value: number) => {
  if (value === 0) return '0'
  if (Math.abs(value) < 1000000) {
    return `${(value / 1000).toFixed(0)} tis.`
  }
  return `${(value / 1000000).toFixed(1).replace('.', ',')} mil.`
}

export const BuybackFormFinancingChart: FunctionComponent<BuybackFormFinancingChartProps> =
  ({ calculations }) => {
    const { scenarios, rentDurationMonths } = calculations

    return (
      <ResponsiveContainer width="100%" height={400}>
        <LineChart
          data={scenarios}
          margin={{ top: 10, right: 0, left: 0, bottom: 10 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="month"
            label={{
              value: 'Měsíc',
              position: 'insideBottom',
              offset: -5,
            }}
          />
          <YAxis
            tickFormatter={formatCurrency}
            label={{
              value: 'Kč',
              angle: -90,
              position: 'insideLeft',
            }}
          />
          <Tooltip
            formatter={(value: number) => `${value.toLocaleString('cs-CZ')} Kč`}
            labelFormatter={(label: number) => `Měsíc ${label}`}
          />
          <Legend verticalAlign="top" height={36} />

          <Line
            type="monotone"
            dataKey="marketBalance"
            stroke="#65a30d"
            strokeWidth={2}
            dot={false}
            name="Tržní prodej"
          />
          <Line
            type="monotone"
            dataKey="buybackBalance"
            stroke="#53afb0"
            strokeWidth={2}
            dot={false}
            name="Zpětný odkup"
          />

          <ReferenceArea
            y2={0}
            ifOverflow="hidden"
            fill="#ff4d4f"
            fillOpacity={0.1}
          />
          <ReferenceArea y1={0} y2={100000} fill="#faad14" fillOpacity={0.1} />

          <ReferenceLine x={rentDurationMonths} stroke="#888888" />
          <ReferenceLine y={0} stroke="#ff6769" />
        </LineChart>
      </ResponsiveContainer>
    )
  }
